import { Component, Input } from '@angular/core';
import { IconComponent } from '@app/components/icon/icon.component';

@Component({
	selector: 'app-info-button',
	standalone: true,
	imports: [IconComponent],
	templateUrl: './info-button.component.html',
	styleUrl: './info-button.component.css',
})
export class InfoButtonComponent {
	@Input() modalId: string = '';
	@Input() title: string = 'Apri finestra con informazioni aggiuntive.';
}
